import Header from "./Header"
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import { AppAction } from "../redux/action";
import { useParams } from "react-router-dom";
import AppHeader from "./AppHeader";
import { useTranslation } from 'react-i18next';

const Releasenotes = ({ appTitle, appIcon, releasenotes, GetAppInfo, GetReleaseNotes }) => {
    const [lang, setLang] = useState('');
    const [contents, setContents] = useState({});
    const { appCode } = useParams();
    const [list, setList] = useState([]);

    const { t, i18n } = useTranslation(['translation']);

    useEffect(() => {
        GetAppInfo(appCode || 'RayLink', lang);
        GetReleaseNotes(appCode || 'RayLink', lang);
    }, [appCode, lang]);

    useEffect(() => {
        setLang(i18n.language);
    }, [i18n.language])

    useEffect(() => {
        setList(releasenotes?.map(x => {
            const result = h2ReplacedContents(x.contents);
            return { ...x, contents: result.contents, subTitle: result.subTitle }
        }));
    }, [releasenotes]);

    useEffect(() => {
        if (list?.length > 0)
            setContents(list[0]);
    }, [list]);

    useEffect(() => {
    }, [contents]);

    const select = (version) => {
        setContents(list.find(x => x.version === version))
    }

    const h2ReplacedContents = (contents) => {
        const div = document.createElement("div");
        div.innerHTML = contents;
        const h2 = div.getElementsByTagName("h2");

        const subTitle = [];

        for (let i = 0; i < h2.length; i++) {
            if (h2[i].innerText.trim() !== '') {
                const id = 'sub_title_' + i
                h2[i].id = id;
                subTitle.push({ id, title: h2[i].innerText });
            }
        }

        return { contents: div.outerHTML, subTitle }
    }

    return (
        <>
            {appCode ? <AppHeader /> : <Header />} 

            <section className="wrapper image-wrapper bg-image bg-overlay bg-overlay-300 text-white" data-image-src="/assets/img/bg1.jpg" style={{ backgroundImage: 'url("/assets/img/bg1.jpg")' }}>
                <div className="container pt-14 pt-md-15 pb-4 pb-md-3">
                    <div className="row gx-lg-9">
                        <div className="col-lg-9">
                            <div className="app-avatar">
                                <img className="avatar" src={appIcon|| '/assets/img/app-icon/img_rayteams.png'} alt={appTitle || 'RAYTeams Client'} />
                            </div>
                            <div className="app-title">
                                <h2 className="fs-15 text-opacity60">{appTitle || 'RAYTeams Client'}</h2>
                                <h3 className="display-5 mf-300 b-0 text-white mb-1">{t('릴리즈 노트')}</h3>
                            </div>
                        </div>
                        <div className="col-lg-3" style={{ display: 'none' }}>
                            <div className="search-form mt-2 mt-md-1 sch-box">
                                <input id="" type="text" className="form-control sch-box" placeholder="Search..." />
                                <label htmlFor="">Search...</label>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container manual">
                <div className="row">
                    <aside className="col-xl-3 order-xl-1 sidebar doc-sidebar py-md-8 py-6 d-xl-block order-1">
                        <div className="widget">
                            <h6 className="widget-title fs-17 mb-2">{t('릴리즈 노트')}</h6>
                            <hr />
                            <div className="accordion accordion-wrapper">
                            {list && 
                                list.map((x,idx) => {
                                    return (                                        
                                        <div className="accordion-item" key={'vlist_' + idx}>
                                            <div className="card-header" id="branch-1">
                                                <button
                                                    className={x.version === contents.version ? '' : 'collapsed'}
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#branch-collapse-1"
                                                    aria-expanded="true"
                                                    aria-controls="branch-collapse-1
                                                          " onClick={() => select(x.version)} >
                                                    <span>
                                                        {x.version}
                                                        {idx === 0 && <a className="badge bg-primary rounded-pill badge-xs">Latest</a>}
                                                    </span>
                                                </button>
                                            </div>

                                            {
                                                x.subTitle.length > 0 && x.version == contents.version &&
                                                (
                                                    <div id="branch-collapse-1" className="card-body accordion-collapse collapse show" aria-labelledby="branch-1">
                                                        <nav id="collapse-style">
                                                            <ul className="list-unstyled fs-sm lh-sm text-reset">
                                                                {
                                                                    x.subTitle.map((y, idx) => {
                                                                        return (
                                                                            <li key={'sub_' + idx}>
                                                                                <a href={'#' + y.id} onClick={(e) => moveTo(history, e, location.pathname + '#test')}>{y.title}</a>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                )
                                            }                                            
                                        </div>                                        
                                    )
                                })
                            }
                            </div>
                            
                        </div>
                    </aside>
                    {releasenotes?.length > 0 && <div className="col-xl-9 order-2 pt-md-8 pb-10">
                        <section className="wrapper">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item"><a href="#">{appTitle || 'RAYTeams Client'}</a></li>
                                    <li className="breadcrumb-item"><a href="#">{t('릴리즈 노트')}</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">{contents.version}</li>
                                </ol>
                            </nav>
                            <h2 className="mt-5">
                                {contents.title + ' '}                               
                                {
                                    contents.version === releasenotes[0]?.version &&
                                    <span className="badge bg-dark rounded-pill badge-xs">Latest</span>
                                }

                            </h2>

                            <div className="applies-to-text-container mb-5">
                                <span className="publish-date-label">Last updated on</span>
                                <span className="publish-date">&nbsp;{moment(contents.created).format('LL')}</span>
                            </div>

                            <div className="board-content">
                                <div className="card-body" dangerouslySetInnerHTML={{ __html: contents.contents }}>
                                   
                                </div>
                            </div>
                        </section>
                        {/* <hr /> */}
                        <div className="quick-btn" style={{ display: 'none' }}>
                            <div className="row g-6">
                                <div className="col-lg-4">
                                    <div className="card shadow-none bg-soft-yellow">
                                        <div className="card-body">
                                            <p className="card-text text-center text-navy">Check out the latest additions and updates to RAYTeams.</p>
                                            <div className="btn btn-yellow rounded-pill text-center w-100 shadow-none"><a href="/community/" className="text-white" target="_blank">What's new</a></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card shadow-none bg-soft-yellow">
                                        <div className="card-body">
                                            <p className="card-text text-center text-navy">Learn how to use RAYTeams and get answers to your questions.</p>
                                            <div className="btn btn-yellow rounded-pill text-center w-100 shadow-none"><a href="/help-center/" className="text-white" target="_blank">Help Center</a></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card shadow-none bg-soft-yellow">
                                        <div className="card-body">
                                            <p className="card-text text-center text-navy">Still have more questions? Please contact us.</p>
                                            <div className="btn btn-yellow rounded-pill text-center w-100 shadow-none"><a href="/contact/#inquiry" className="text-white" target="_blank">1:1 Inquiry</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    )
}

const mapState = (state) => {
    const { appTitle, appIcon, releasenotes } = state.AppReducer;
    return { appTitle, appIcon, releasenotes };
}

const mapDispatch = dispatch => ({
    GetAppInfo: (appCode) => dispatch(AppAction.GetAppInfo(appCode, 'ko')),
    GetReleaseNotes: (appCode, lang) => dispatch(AppAction.GetReleaseNotes(appCode, lang))
})

export default connect(mapState, mapDispatch)(Releasenotes);
